import cookies from 'js-cookie';
import config from '../config/user.env';
import axios from 'axios';
import api from '@/modules/index/api/gsc';

/**
 * 用正则表达式实现html非常规字符转码
 */
export const escape2Html = (str) => {
  const arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, (all, t) => {
      return arrEntities[t];
  });
};
/**
* html编码，解决XSS漏洞
*/
export const htmlEncode = (html) => {
  let temp = document.createElement('div');
  temp.textContent !== undefined ? (temp.textContent = html) : (temp.innerText = html);
  const output = temp.innerHTML;
  temp = null;
  const encodeHtml = escape2Html(output);
  return encodeHtml;
};

/**
 * 退出登录
 */
export function logout(router) {
  // return axios({
  //     url: '/mframework/logout',
  //     method: 'get'
  // }).then(res => {
  //     if (res.data.data.code === '200') {
  //         clearCookie();
  //         localStorage.clear();
  //         logoutAccount();
  //         window.location.href = htmlEncode(`${api.logoutUrl}?service=${window.location.origin}`);
  //     }
  //     return res.data;
  // });
    return new Promise((resolve) => {
        resolve();
        clearCookie();
        localStorage.clear();
        logoutAccount();
        window.location.href = htmlEncode(`${api.logoutUrl}?service=${window.location.origin}`);
    });
  // window.location.href = config.singlePointLogin + window.location.href;
}

/**
 * 判断是否登录
 * @param {*} router 路由
 */
export function checkLogin(router) {
  router.beforeEach((to, from, next) => {
    const masTGC = cookies.get(config.MAS_TGC);
    // 判断是否已登录
    if (masTGC || to.path === '/banner') {
      next();
    } else {
      if (to.path === '/login') {
        next();
      } else {
        if (window.location.href.indexOf('/globalprotal.html') > -1) {
          window.location.href = `//${window.location.host}`;
        } else {
          next({
            name: 'login'
          });
        }
      }
    }
  });
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const date = new Date(time);
  let fmt = cFormat || 'yyyy-MM-dd hh:mm:ss';
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach(k => {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  });
  return fmt;
}

/**
 * 设置cookie
 * @param name 键
 * @param value 值
 * @param domain 域
 */
export const setCookie = (name, value, params) => {
  document.cookie = name + '=' + value + ';domain=' + (params && params.domain) || window.location.hostname;
};

/**
 * 获取主域
 * @param weburl
 * @returns {string}
 */
export const getDomain = (host = document.domain) => {
  let hostExts = ['.com', '.cn', '.net', '.cc', '.sh', '.org'];
  let ext = [];
  let reExt;
  let exist = false;
  for (var i = 0; i < hostExts.length; i++) {
    if (host.indexOf(hostExts[i]) !== -1) {
      ext[ext.length] = hostExts[i];
      reExt = new RegExp('\\' + hostExts[i]);
      host = host.replace(reExt, '{' + (ext.length - 1) + '}');
      exist = true;
    } else {
      break;
    }
  }
  if (!exist) {
    return host;
  }
  var hostarray = host.split('.');
  host = hostarray[hostarray.length - 1];
  for (let i = 0; i < ext.length; i++) {
    reExt = new RegExp('\\{' + i + '\\}');
    host = host.replace(reExt, ext[i]);
  }
  return host;
};
/**
 * 清除所有cookie
 */
export const clearCookie = () => {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      cookies.remove(keys[i], {
        expires: new Date(0).toUTCString()
      });
      cookies.remove(keys[i], {
        expires: new Date(0).toUTCString(),
        domain: getDomain()
      });
    }
  }
};
  /**
   * 路由标题国际化转换
   * @param {*} title 标题
   */
export const generateTitle = function (title) {
  const hasKey = this.$t(title);
  const translatedTitle = this.$t(title);
  if (hasKey) {
    return translatedTitle;
  }
  return title;
}

export const request = function (url, params, method = 'POST') {
  var array = url.split('/');
  return axios({
    method,
    url,
    data: {
      sqlId: array[array.length - 1],
      fname,
      appId: systemAppId,
      ...params
    }
  });
};

/**
 * 异步请求数据打印前的初化操作
 */
export const poolPrintPreDo = function() {
  if (IEVersion() === -1) {
    window.printWindow = window.open();
  }
};

/* 运维切换退出登录 */
export const logoutAccount = () => {
    const uuidNum = localStorage.getItem('UUID_NUM');
    const vendorCode = localStorage.getItem('vendorCode');
    if (uuidNum && vendorCode) {
        axios.post('/gscint/switchAccountOfOperation/logoutAccount', {
            uuidNum,
            vendorCode,
        });
    }
};


/* 替换hk域名为国内域名 */
export const replaceHostName = (hostName) => {
    return hostName.replace(/(gsc)(hk|-hk|eu|-eu|us|-us)?(.*)/g, '$1$3');
};
